<template>
	<div id="MobileGame" v-if="device" :class="[{['bg_' + (characterSelect + 1)] : moSceneStep !== '' && moSceneStep !== 'selectCharacter'}, {'bgMask': moSceneStep === 'help' || moSceneStep === 'ending'}]">
		<div class="selectCharacter" v-if="moSceneStep === 'selectCharacter'">
			<h2 class="sceneTitle"><img src="/static/img/mobile/title-chose.png" height="40" width="131" alt="連結裝置"></h2>
			<div id="slider" class="characterList" v-touch:touchstart="onTouchStart" v-touch:touchmove="onTouchMove">
				<div class="characterUnit" :class="[{'selected': index === 0}, character[index].className]" v-for="(item, index) in character">
					<div class="pic">
						<div class="img"></div>
					</div>
					<p class="text">{{ item.name }}</p>
					<div class="dialog">
						<p :class="{'oneLine': !item.dialogLine2}">{{ item.dialogLine1 }}</p>
						<p v-if="item.dialogLine2">{{ item.dialogLine2 }}</p>
					</div>
				</div>
			</div>
			<span class="btn arrow prev" v-if="nowShowCharacter !== 0" @click="prevcharacter"></span>
			<span class="btn arrow next" v-if="nowShowCharacter !== character.length - 1" @click="nextcharacter"></span>
			<p class="hintSwitch">請左右切換選擇角色</p>
			<button class="btn confirm" @click="chosecharacter"><span>搶發財金</span></button>
		</div>

		<div class="help" v-if="moSceneStep === 'help'">
			<div class="hint" v-if="helpStep !== 2">
				<div class="dialog">
					<p v-if="helpStep === 0">左右擺動手機<br>即可控制人物移動!</p>
					<p v-if="helpStep === 1">來練習一下<br>接住發財金吧</p>
				</div>
			</div>
			<div class="helpStep helpStep1" v-if="helpStep === 0">
				<div class="hintPic"></div>
			</div>
			<div class="helpStep helpStep2" v-if="helpStep === 1"></div>
			<div class="helpStep helpStep3" v-if="helpStep === 2">
				<div class="dialogReady">
					<p class="text">等不及發大財了嗎？<br>立刻去搶發財金吧！</p>
				</div>
			</div>
		</div>

		<div class="mainGame" v-if="moSceneStep === 'mainGame'">

			<div class="timer">00:<span v-if="(nowProgress / 1000).toFixed(0) <= 9">0</span>{{ (nowProgress / 1000).toFixed(0) }}</div>
			<div class="scoreboard">${{ totalPoint }}</div>
			<div class="startCountDown">
				<p v-for="(item, index) in startCountDownTxt">{{ item }}</p>
			</div>
		</div>

		<div class="ending" v-if="moSceneStep === 'ending'">
			<div class="outcome">
				<p class="textHint">發財金不夠？再撈一筆！</p>
				<div class="outcomeBox">
					<div class="pic" :class="'outcome_' + (characterSelect + 1) + '-' + (characterState + 1)"></div>
					<div class="totalMoney">
						<p class="text">恭喜獲得發財金</p>
						<p class="money"><span>$</span> {{ totalPoint }}</p>
					</div>
				</div>
				<div class="btnSection">
					<span class="btn replay" @click="replay">
						<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="39px" height="39px" viewBox="0 0 39 39" enable-background="new 0 0 39 39" xml:space="preserve">
							<path fill="#FFFFFF" d="M24.389,20.723c0,2.698-2.188,4.889-4.889,4.889c-2.699,0-4.889-2.19-4.889-4.889 c0-2.702,2.189-4.889,4.889-4.889v2.444l6.355-4.889L19.5,8.5v2.444c-5.398,0-9.777,4.377-9.777,9.778 c0,5.398,4.379,9.777,9.777,9.777s9.777-4.379,9.777-9.777H24.389z"/>
						</svg><span class="text">再撈一筆</span>
					</span>
					<a class="btn fbShare" target="_blank" @click="fbShare" :href="'http://www.facebook.com/sharer.php?u=http://2018ny.sobo.com.tw/static/fb/outcome-' + character[characterSelect].className + '_' + (characterState + 1) + '.html'">
						<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="39px" height="39px" viewBox="0 0 39 39" enable-background="new 0 0 39 39" xml:space="preserve">
							<path fill="#FFFFFF" d="M24.802,20.509l0.528-4.089h-4.049v-2.61c0-1.184,0.33-1.99,2.027-1.99l2.163-0.002V8.161 C25.099,8.112,23.814,8,22.317,8c-3.122,0-5.258,1.906-5.258,5.405v3.015h-3.531v4.089h3.531V31h4.222V20.509H24.802z"/>
						</svg>
					</a>
					<a class="btn lineShare" target="_blank" href="http://line.naver.jp/R/msg/text/?2018%E6%97%BA%E6%97%BA%E5%B9%B4%EF%BC%8C%E6%8B%BF%E5%87%BA%E4%BD%A0%E7%9A%84%E6%89%8B%E6%A9%9F%E9%80%A3%E5%8B%95%E9%9B%BB%E8%85%A6%EF%BC%8C%E6%90%B6%E7%99%BC%E8%B2%A1%E9%87%91%E9%81%8E%E5%A5%BD%E5%B9%B4%E3%80%82http://2018ny.sobo.com.tw&from=line_scheme&2018%E6%97%BA%E6%97%BA%E5%B9%B4%EF%BC%8C%E6%8B%BF%E5%87%BA%E4%BD%A0%E7%9A%84%E6%89%8B%E6%A9%9F%E9%80%A3%E5%8B%95%E9%9B%BB%E8%85%A6%EF%BC%8C%E6%90%B6%E7%99%BC%E8%B2%A1%E9%87%91%E9%81%8E%E5%A5%BD%E5%B9%B4%E3%80%82http://2018ny.sobo.com.tw" @click="lineShare">
						<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="39px" height="39px" viewBox="0 0 39 39" enable-background="new 0 0 39 39" xml:space="preserve">
							<path fill="#FFFFFF" d="M19.5,8c-6.655,0-12.069,4.394-12.069,9.794c0,4.842,4.293,8.897,10.094,9.664 c0.393,0.085,0.928,0.26,1.063,0.596c0.121,0.305,0.079,0.783,0.038,1.091c0,0-0.142,0.852-0.172,1.033 c-0.053,0.306-0.242,1.193,1.046,0.65c1.288-0.542,6.95-4.093,9.482-7.007c1.749-1.918,2.587-3.865,2.587-6.027 C31.569,12.394,26.155,8,19.5,8z M15.241,20.679c0,0.129-0.104,0.235-0.234,0.235h-3.382h-0.001c-0.063,0-0.12-0.025-0.162-0.066 c-0.001-0.001-0.002-0.002-0.003-0.003c-0.002-0.001-0.003-0.002-0.004-0.004c-0.04-0.042-0.065-0.099-0.065-0.162v-5.259 c0-0.129,0.105-0.235,0.235-0.235h0.847c0.13,0,0.234,0.105,0.234,0.235v4.177h2.301c0.13,0,0.234,0.105,0.234,0.235V20.679z M17.282,20.679c0,0.13-0.105,0.234-0.234,0.234h-0.847c-0.13,0-0.235-0.104-0.235-0.234v-5.259c0-0.129,0.105-0.235,0.235-0.235 h0.847c0.129,0,0.234,0.105,0.234,0.235V20.679z M23.109,20.679c0,0.13-0.105,0.234-0.235,0.234h-0.847 c-0.021,0-0.041-0.003-0.06-0.008c-0.001,0-0.003-0.001-0.004-0.001c-0.005-0.001-0.01-0.003-0.016-0.005 c-0.003-0.001-0.005-0.002-0.007-0.003c-0.005-0.001-0.008-0.003-0.012-0.005c-0.004-0.001-0.008-0.003-0.012-0.005 c-0.002-0.002-0.004-0.002-0.006-0.004c-0.005-0.003-0.01-0.006-0.015-0.009c-0.001-0.001-0.002-0.001-0.003-0.002 c-0.021-0.015-0.043-0.034-0.06-0.058l-2.412-3.26v3.124c0,0.13-0.105,0.234-0.235,0.234h-0.847c-0.13,0-0.235-0.104-0.235-0.234 v-5.259c0-0.129,0.105-0.235,0.235-0.235h0.847c0.003,0,0.005,0,0.008,0c0.004,0,0.009,0,0.012,0.001c0.005,0,0.009,0,0.013,0.001 c0.004,0,0.007,0,0.01,0.001c0.005,0.001,0.01,0.002,0.014,0.003c0.003,0,0.006,0.001,0.008,0.002 c0.005,0.001,0.01,0.003,0.015,0.004c0.003,0.001,0.005,0.002,0.008,0.003c0.005,0.001,0.009,0.003,0.014,0.006 c0.002,0.001,0.005,0.002,0.007,0.003c0.004,0.002,0.009,0.004,0.013,0.007c0.002,0.001,0.005,0.002,0.007,0.004 c0.004,0.002,0.009,0.005,0.013,0.008c0.002,0.001,0.004,0.003,0.006,0.005c0.004,0.003,0.009,0.007,0.013,0.01 c0.001,0.001,0.003,0.003,0.004,0.004c0.005,0.005,0.01,0.009,0.015,0.015l0.001,0.001c0.007,0.008,0.013,0.016,0.019,0.024 l2.41,3.255v-3.125c0-0.129,0.104-0.235,0.234-0.235h0.847c0.13,0,0.235,0.105,0.235,0.235V20.679z M27.784,16.267 c0,0.13-0.104,0.235-0.234,0.235h-2.301v0.889h2.301c0.13,0,0.234,0.105,0.234,0.235v0.847c0,0.13-0.104,0.235-0.234,0.235h-2.301 v0.889h2.301c0.13,0,0.234,0.105,0.234,0.235v0.847c0,0.129-0.104,0.235-0.234,0.235h-3.382h-0.001 c-0.063,0-0.12-0.025-0.162-0.066c-0.001-0.001-0.003-0.002-0.003-0.003c-0.002-0.001-0.003-0.002-0.004-0.004 c-0.04-0.042-0.065-0.099-0.065-0.162V15.42v0c0-0.063,0.024-0.12,0.065-0.162c0.001-0.001,0.002-0.003,0.004-0.004 c0-0.001,0.001-0.001,0.002-0.002c0.043-0.041,0.1-0.066,0.163-0.066h0.001h3.382c0.13,0,0.234,0.105,0.234,0.235V16.267z"/>
						</svg>
					</a>
				</div>
			</div>
			<div class="linkSection">
				<a target="_blank" href="http://www.sobo.com.tw/design/" @click="openSobo" class="logoSobo"><img src="/static/img/link-sobo.png" alt="SOBO 淞泊創意設計"></a>
				<a target="_blank" href="http://www.weddings.tw/" @click="openWedding" class="logoWeddings"><img src="/static/img/link-weddings.png" alt="Weddings 新娘物語"></a>
			</div>
		</div>


		<div class="gameItem" v-if="moSceneStep === 'help' || moSceneStep === 'mainGame'" :style="{width: sceneWidth + 'px', marginLeft: sceneWidth / -2 + 'px',}">
			<div class="demoTreasure" v-if="moSceneStep === 'help'">
				<div class="treasure" :data-point="demoFallingTreasure[index][1]" :class="demoFallingTreasure[index][0]" v-for="(item, index) in demoFallingTreasure" :style="{
					width: demoFallingTreasure[index][2][0] / 2 + 'px',
					height: demoFallingTreasure[index][2][1] / 2 + 'px',
					top: '-10%'
				}"></div>
			</div>

			<div class="treasureGroup" v-if="moSceneStep === 'mainGame'">
				<div class="treasure" :data-point="fallingTreasureList[index][1]" :class="[fallingTreasureList[index][0], 'tIndex_' + (index + 1)]" v-for="(item, index) in fallingTreasureList" :style="{
					width: fallingTreasureList[index][2][0] / 2 + 'px',
					height: fallingTreasureList[index][2][1] / 2 + 'px',
					top: '-10%'
				}">
				</div>
			</div>

			<div class="treasureCore" :style="{
				width: treasureBoxWidth + 'px',
				height: treasureBoxHeight + 'px',
				top: 0,
				left: ((sceneWidth - treasureBoxWidth) / 2 - 100) + 'px',
			}" v-if="(moSceneStep === 'help' && helpStep !== 2) || (moSceneStep !== 'help' && moSceneStep !== 'ending')" :class="{'notOnRoof': moSceneStep === 'help' || moSceneStep === 'mainGame'}"></div>

			<div class="avatar" v-if="(moSceneStep === 'help' && helpStep === 1) || moSceneStep === 'mainGame'" :style="{
				marginLeft: 'auto',
				width: character[characterSelect].avatarSize[characterState].width / 2 + 'px',
				height: character[characterSelect].avatarSize[characterState].height / 2 + 'px',
				transform: 'translateX(' + data + 'px)',
				MozTransform: 'translateX(' + data + 'px)',
				WebkitTransform: 'translateX(' + data + 'px)',
				msTransform: 'translateX(' + data + 'px)'
			}" :class="[character[characterSelect].className, 'state_' + (characterState + 1)]">
				<div class="valueHint">+ {{ getValue }} </div>
			</div>

			<div class="block" v-if="moSceneStep === 'help' || moSceneStep === 'mainGame'" :class="[{'popout': blockCoordinate}, character[randomBlock].className, 'state_' + (randomBlockState + 1)]" :style="{
				width: character[randomBlock].avatarSize[randomBlockState].width / 2 + 'px',
				height: character[randomBlock].avatarSize[randomBlockState].height / 2 + 'px',
				left: (blockLastCoordinate + sceneWidth / 2) + 'px',
				marginLeft: character[randomBlock].avatarSize[randomBlockState].width / -4 + 'px',
				paddingBottom: '15px'
			}"></div>
		</div>
	</div>
	<div class="redirect" v-else>
		<div class="alert">
			<div class="alertBox">
				<p class="text alertType">請回首頁</p>
				<p class="text alertText">重新開始遊戲</p>
				<router-link class="btn" :to="'/'" replace><span>確定</span></router-link>
			</div>
		</div>
		<router-link v-if="!device" :to="'/'" replace>確定</router-link>
	</div>
</template>

<script>
	import { mapActions, mapGetters } from 'vuex'

	export default {
		name: 'MobileGame',
		data () {
			return {
				moSceneStep: 'selectCharacter',
				helpStep: 0,


				characterSelect: 0, // 選中角色 index
				characterState: 0, // 角色階段
				nowShowCharacter: 0,

				demoFallingTreasure: [], // 用於存放教學掉落寶藏

				data: 0, // 陀螺儀資料


				treasureTotalNum: 20, // 掉落寶物總數
				treasureNum: 0,
				fallingTreasureList: [], // 遊戲開始掉落寶物列表
				treasureGet: [], // 用於存放得到寶物
				totalPoint: 0, // 總分


				startCountDownTxt: ['参', '貳', '壹', '開始'],


				totalSecond: 15000, // 遊戲總時間
				nowProgress: 15000, // 存放遊戲目前秒數
				timer: null, // 遊戲秒數計時器

				alertType: '',
				alertText: '', // 錯誤資訊
				error: false, // 判斷連結是否有誤
				sendPause: false, // 用以暫停手機陀螺儀傳輸
				reset: false,

				sceneWidth: $(window).width(),

				treasureBoxPosition: [],
				treasureBoxWidth: 80,
				treasureBoxHeight: 80,
				treasureBoxChangeWayTime: [],
				treasureBoxMoving: false,
				getValue: 0,


				blockCoordinate: null,
				blockLastCoordinate: null,
				blockWidth: 80,
				randomBlock: 0,
				randomBlockState: 0,


				// xDown: null,
				// yDown: null,
			}
		},
		computed: {
			...mapGetters({
				roomNum: 'getRoomCode',
				device: 'isMobile',
				character: 'getCharacter',
				treasureList: 'getTreasure'
			})
		},
		methods: {
			...mapActions([
				'setDevice'
			]),
			openSobo: function () {
				gtag('event', 'click', {'event_category': 'Sobo New Year', 'event_label': '點擊Logo'});
				window.open("http://www.sobo.com.tw/design/");
			},
			openWedding: function () {
				window.open("http://www.weddings.tw/");
			},
			fbShare: function () {
				let url = 'http://www.facebook.com/sharer.php?u=http://2018ny.sobo.com.tw/static/fb/outcome-' + this.character[this.characterSelect].className + '_' + (this.characterState + 1) + '.html';
				window.open(url);
			},
			lineShare: function () {
				var link = "http://line.naver.jp/R/msg/text/?";
				link += encodeURIComponent('2018旺旺年，拿出你的手機連動電腦，搶發財金過好年。') + 'http://2018ny.sobo.com.tw';
				window.open(link);
			},
			onTouchStart: function (evt) {
				this.xDown = evt.touches[0].clientX;
				this.yDown = evt.touches[0].clientY;
			},
			onTouchMove: function (evt) {
				let self = this;
				if (!self.xDown || !self.yDown) {
					return;
				}

				let xUp = evt.touches[0].clientX;
				let yUp = evt.touches[0].clientY;

				let xDiff = self.xDown - xUp;
				let yDiff = self.yDown - yUp;

				let position = Math.round(parseInt($("#slider").css("marginLeft"), 10) / $("#slider").width() * -6);
				self.playMusic('selectMusic');

				if (Math.abs(xDiff) > Math.abs(yDiff)) {
					if (xDiff > 0) {
						/* left swipe */
						if (position === self.character.length - 1) {
							return false;
						} else {
							$("#slider").animate({
								"marginLeft": (position + 1) * -100 + '%'
							}, {
								complete: function () {
									$(".characterUnit").removeClass('selected').eq(position + 1).addClass('selected');
									self.nowShowCharacter = position + 1;
								},
								duration: 500
							});
						}

					} else {
						/* right swipe */
						if (position === 0) {
							return false;
						} else {
							$("#slider").animate({
								"marginLeft": (position - 1) * -100 + '%'
							}, {
								complete: function () {
									$(".characterUnit").removeClass('selected').eq(position - 1).addClass('selected');
									self.nowShowCharacter = position - 1;
								},
								duration: 500
							});
						}
					}
				} else {
					if (yDiff > 0) {} else {}
				}
				self.xDown = null;
				self.yDown = null;
			},


			// 隨機寶藏
			randomTreasure: function () {
				let treasureBox = [];

				function probabilityArray() {
					for (let i = 0; i < arguments[0].length; i++) {
						for (let x = 0; x < arguments[0][i].probability; x++) {
							if (arguments[0][i].name === 'diamond') {
								treasureBox.push([arguments[0][i].name + Math.round(Math.random() * 2 + 1), arguments[0][i].value, arguments[0][i].size]);
							} else {
								treasureBox.push([arguments[0][i].name, arguments[0][i].value, arguments[0][i].size]);
							}
						}
					}
				}
				probabilityArray(this.treasureList);

				for (let y = 0; y < this.treasureList.length; y++) {
					if (this.treasureList[y].name === 'diamond') {
						this.fallingTreasureList.push([this.treasureList[y].name + Math.round(Math.random() * 2 + 1), this.treasureList[y].value, this.treasureList[y].size]);
					} else {
						this.fallingTreasureList.push([this.treasureList[y].name, this.treasureList[y].value, this.treasureList[y].size]);
					}
				}
				for (let x = 4; x < this.treasureTotalNum; x++) {
					let pustin = treasureBox[Math.floor(Math.random() * treasureBox.length)];
					this.fallingTreasureList.push(pustin);
				}
				this.fallingTreasureList.sort(function () {return Math.random() > 0.5 ? -1 : 1;});
			},

			// 寶物移動功能
			moving: function (item, duration) {
				let self = this;
				if (self.error) {
					return false;
				}

				$(item).css({
					opacity: 1,
					top: '80px',
					left: parseInt($(".treasureCore").css('left'), 10) + (self.treasureBoxWidth / 2) - 25 + 'px',
				}).stop(false, true).animate({
					top: '110%'
				}, {
					step: function (now, fx) {
						if (self.error) {
							return false;
						}
						let foodx = $(this).offset().left + $(this).width() / 2;
						let foody = $(this).offset().top + $(this).height() / 2;

						if (foody > $(".avatar").offset().top && foody < $(".avatar").offset().top + $(".avatar").height()) {
							if (foodx > $(".avatar").offset().left && foodx < $(".avatar").offset().left + $(".avatar").width()) {
								self.playMusic('catchMusic');
								if (self.treasureGet.indexOf(item) < 0) {
									self.getValue = parseInt($(this).attr("data-point"), 10);
									self.totalPoint += parseInt($(this).attr("data-point"), 10);
									self.treasureGet.push($(this).attr("class"));
									$(".avatar").addClass('catch');
									$(".valueHint").stop(false, true).animate({
										top: "-50px",
										opacity: 1
									}, {
										duration: 500,
										complete: function () {
											$(".valueHint").attr("style", "");
										},
									}, 'ease-in-out');
									setTimeout(function () {
										$(".avatar").removeClass('catch');
									}, 200);
									$(this).hide();
								}
							}
						}
					},
					duration: duration
				}, 'ease-in-out');
			},
			treasureFall: function () {
				if (this.treasureNum === 20 ) {
					return false;
				}

				if (this.treasureNum <= 19 ) {
					let self = this;
					let n = Math.floor(this.totalSecond / this.treasureTotalNum / 100) * 100;
					let randomNext = n + Math.floor(Math.random() * 200) * (Math.round(Math.random()) * 2 - 1);
					let randomDur = ( (this.totalSecond - (15000 - this.nowProgress) - randomNext) > 3000 ) ? (Math.round(Math.random() * 25) + 5) * 100 : (this.totalSecond - (15000 - this.nowProgress) - randomNext);

					this.treasureNum++;
					if ($(".treasureCore").hasClass("ml")) {
						$(".treasureCore").addClass("left");
					}
					if ($(".treasureCore").hasClass("mr")) {
						$(".treasureCore").addClass("right");
					}
					setTimeout(function () {
						$(".treasureCore").removeClass("left right");
					}, 200);
					this.moving(".tIndex_" + this.treasureNum, randomDur);
					setTimeout(function () {
						self.treasureFall();
					}, randomNext);
				}
			},


			//
			treasureBoxMove: function (target, i) {
				let self = this;
				let n = i;

				if (self.treasureBoxMoving) {
					return false;
				}
				self.treasureBoxMoving = true;


				target.removeClass("ml mr");
				if (parseInt(target.css("left"), 10) > self.treasureBoxPosition[n]) {
					target.addClass("ml");
				}
				if (parseInt(target.css("left"), 10) < self.treasureBoxPosition[n]) {
					target.addClass("mr");
				}


				if (i === 0) {
					target.stop(false, true).animate({
						left: self.treasureBoxPosition[n]
					}, {
						duration: self.treasureBoxChangeWayTime[n],
						complete: function () {
							self.treasureBoxMoving = false;
							self.treasureBoxMove(target, n + 1);
						},
					}, 'ease-in-out');
				} else {
					target.css({
						left: self.treasureBoxPosition[n - 1]
					}).stop(false, true).animate({
						left: self.treasureBoxPosition[n],
					}, {
						duration: self.treasureBoxChangeWayTime[n],
						complete: function () {
							if (self.treasureBoxPosition.length - n > 1 && (15000 - self.nowProgress) !== self.totalSecond) {
								self.treasureBoxMoving = false;
								self.treasureBoxMove(target, n + 1);
							}
						},
					}, 'ease-in-out');
				}
			},
			treasureBoxPath: function () {
				this.treasureBoxPosition = [];
				let self = this;
				let turnBackTime = 10 + Math.floor(Math.random() * 3) * (Math.round(Math.random()) * 2 - 1);

				for (let i = 0; i < turnBackTime; i++) {
					let direction = Math.round(Math.random()) * 2 - 1;
					let time = Math.floor(self.totalSecond / turnBackTime);
					let randomChangeWayTime = time + Math.floor(Math.random() * 800) * (Math.round(Math.random()) * 2 - 1);

					if (i > 0) {
						if (direction * self.treasureBoxPosition[i - 1] > 0) {
							self.treasureBoxPosition.push( Math.floor(Math.random() * ((self.sceneWidth - self.treasureBoxWidth) / 2)) * direction);
						} else {
							self.treasureBoxPosition.push( self.treasureBoxPosition[i - 1] + ( ((self.sceneWidth / 2 * 0.6) + Math.floor(Math.random() * (self.sceneWidth / 2 * 0.4)) -  self.treasureBoxWidth / 2 ) * direction));
						}
					} else {
						self.treasureBoxPosition.push( Math.floor(Math.random() * ((self.sceneWidth - self.treasureBoxWidth) / 2)) * direction);
					}

					if (i === turnBackTime - 1) {
						let last = self.totalSecond;
						for (let l = 0; l < i; l++) {
							last -= self.treasureBoxChangeWayTime[l];
						}
						self.treasureBoxChangeWayTime.push(last);
					} else {
						self.treasureBoxChangeWayTime.push(randomChangeWayTime);
					}
				}
				self.treasureBoxPosition = self.treasureBoxPosition.map(function (x) {
					return (x + (self.sceneWidth / 2)) - (self.treasureBoxWidth / 2);
				});
				this.treasureBoxMove($(".treasureCore"), 0);
			},


			// demo相關
			demoTreasureBoxMove: function () {
				let self = this;
				let randomXCoordinate = Math.floor(Math.random() * (self.sceneWidth - self.treasureBoxWidth));



				$(".treasureCore").removeClass("ml mr");
				if (parseInt($(".treasureCore").css("left"), 10) > randomXCoordinate) {
					$(".treasureCore").addClass("ml");
				}
				if (parseInt($(".treasureCore").css("left"), 10) < randomXCoordinate) {
					$(".treasureCore").addClass("mr");
				}


				$(".treasureCore").stop(false, true).animate({
					left: randomXCoordinate
				}, {
					duration: Math.floor(Math.random() * 400) + 1000,
					complete: function () {
						if (self.treasureGet.length === 0 && self.moSceneStep === "help") {
							self.demoTreasureBoxMove();
						}
					}
				}, 'ease-in-out');
			},
			demoTreasureFall: function () {
				if ($(".treasureCore").hasClass("ml")) {
					$(".treasureCore").addClass("left");
				}
				if ($(".treasureCore").hasClass("mr")) {
					$(".treasureCore").addClass("right");
				}
				setTimeout(function () {
					$(".treasureCore").removeClass("left right");
				}, 200);

				let self = this;
				$(".treasure").css({
					opacity: 1,
					top: '140px',
					left: parseInt($(".treasureCore").css('left'), 10) + (self.treasureBoxWidth / 2) - 25 + 'px',
				}).stop(false, true).animate({
					top: '101%'
				}, {
					duration: Math.floor(Math.random() * 1000) + 700,
					complete: function () {
						if (self.treasureGet.length === 0 && self.moSceneStep === "help") {
							let randomNum = Math.floor(Math.random() * self.treasureList.length);

							self.demoFallingTreasure = [];
							if (self.treasureList[randomNum].name === 'diamond') {
								self.demoFallingTreasure.push([self.treasureList[randomNum].name + Math.round(Math.random() * 2 + 1), self.treasureList[randomNum].value, self.treasureList[randomNum].size]);
							} else {
								self.demoFallingTreasure.push([self.treasureList[randomNum].name, self.treasureList[randomNum].value, self.treasureList[randomNum].size]);
							}
							self.demoTreasureFall();
						}
					},
					step: function (now, fx) {
						let foodx = $(this).offset().left + $(this).width() / 2;
						let foody = $(this).offset().top + $(this).height() / 2;

						if (foody > $(".avatar").offset().top && foody < $(".avatar").offset().top + $(".avatar").height()) {
							if (foodx > $(".avatar").offset().left && foodx < $(".avatar").offset().left + $(".avatar").width()) {
								self.playMusic('catchMusic');
								if (self.treasureGet.indexOf($(this).attr("class")) < 0) {
									self.getValue = parseInt($(this).attr("data-point"), 10);
									self.treasureGet.push($(this));
									$(".valueHint").stop(false, true).animate({
										top: "-50px",
										opacity: 1
									}, {
										duration: 500,
										complete: function () {
											$(".valueHint").attr("style", "");
										},
									}, 'ease-in-out');
									$(".avatar").addClass('catch');
									setTimeout(function () {
										$(".avatar").removeClass('catch');
									}, 200);
									$(this).hide();
								}
							}
						}
					}
				}, 'ease-in-out');
			},
			demo: function () {
				let self = this;
				setTimeout(function () {
					$(".help > .hint > .dialog").addClass('show');
				}, 500);
				setTimeout(function () {
					$(".help .dialog").removeClass('show');
					self.helpStep = 1;
				}, 7000);
			},



			//時間倒數
			countDown: function () {
				let self = this;
				if (self.error) {
					return false;
				}
				if ((15000 - self.nowProgress) === self.totalSecond) {
					clearTimeout(self.timer);
					self.treasureBoxMoving = true;
					setTimeout(function () {
						self.moSceneStep = 'ending';
					}, 1000);
					return false;
				} else {
					self.nowProgress -= 100;
					clearTimeout(self.timer);
					self.timer = setTimeout(self.countDown, 100);
				}
			},
			deleteRandom: function (ind) {
				let aa = [];
				for (let i = 0; i < 5; i++) {
					if (i !== ind) {
						aa.push(i);
					}
				}
				return aa;
			},

			blockShowing: function () {
				let self = this;
				if (this.error) {
					return false;
				}
				if ((15000 - self.nowProgress) >= self.totalSecond - 2000) {
					self.blockLastCoordinate = null;
					return false;
				} else {
					let randomShow = Math.round(Math.random() * 1);
					let randomIdx = self.deleteRandom(self.characterSelect);

					self.randomBlock = randomIdx[Math.round(Math.random() * (randomIdx.length - 1))];
					self.randomBlockState = Math.round(Math.random() * 2);
					self.blockLastCoordinate = null;

					if (randomShow === 0) {
						setTimeout(function () {
							self.blockShowing();
						}, Math.floor(Math.random() * 2000));
					} else {
						if (self.data > 0) {
							self.blockCoordinate = randomShow * -1 * Math.round(Math.random() * (self.sceneWidth / 2 - self.character[self.randomBlock].avatarSize[self.randomBlockState].width / 4));
						} else {
							self.blockCoordinate = randomShow * Math.round(Math.random() * (self.sceneWidth / 2 - self.character[self.randomBlock].avatarSize[self.randomBlockState].width / 4));
						}


						self.blockLastCoordinate = self.blockCoordinate;

						$(".block").off("webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend").on("webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend", function(event) {
							if ($(".block").hasClass("popout")) {
								setTimeout(function () {
									self.blockCoordinate = null;
								}, Math.floor(Math.random() * 1500));
							} else {
								self.blockShowing();
							}
						});
					}
				}
			},







			// 陀螺儀傳輸
			sendIt: function (event) {
				if (this.sendPause) {
					return false;
				}
				let rotateLimit = 90;
				let leftLimit;
				let rightLimit;
				if (event.beta < 150 && Math.abs(event.gamma) < rotateLimit) {
					if (this.blockLastCoordinate) {
						if (this.data < this.blockLastCoordinate) {
							rightLimit = this.blockLastCoordinate - (this.character[this.randomBlock].avatarSize[this.randomBlockState].width / 4) - (this.character[this.characterSelect].avatarSize[this.characterState].width / 4);
							leftLimit = (this.sceneWidth / 2 - this.character[this.characterSelect].avatarSize[this.characterState].width / 4) * -1;
						} else {
							rightLimit = this.sceneWidth / 2 - this.character[this.characterSelect].avatarSize[this.characterState].width / 4;
							leftLimit = this.blockLastCoordinate + (this.character[this.randomBlock].avatarSize[this.randomBlockState].width / 4) + (this.character[this.characterSelect].avatarSize[this.characterState].width / 4);
						}
					} else {
						rightLimit = this.sceneWidth / 2 - this.character[this.characterSelect].avatarSize[this.characterState].width / 4;
						leftLimit = (this.sceneWidth / 2 - this.character[this.characterSelect].avatarSize[this.characterState].width / 4) * -1;
					}



					if (event.gamma > 4) {
						if (this.data >= rightLimit) {
							this.data = rightLimit;
						} else {
							this.data += (4 + 3 * Math.abs(event.gamma) / rotateLimit);
						}
					}
					if (event.gamma < -4) {
						if (this.data <= leftLimit) {
							this.data = leftLimit;
						} else {
							this.data -= (4 + 3 * Math.abs(event.gamma) / rotateLimit);
						}
					}

				}
				this.alpha = event.alpha;
				this.beta = event.beta;
				this.gamma = event.gamma;
			},
				// 手機陀螺儀功能開放
			addEvent: function () {
				window.addEventListener("deviceorientation", this.sendIt, false);
			},
			removeEvent: function () {
				window.removeEventListener("deviceorientation", this.sendIt, false);
			},



			nextcharacter: function (event) {
				let self = this;
				let position = Math.round(parseInt($("#slider").css("marginLeft"), 10) / $("#slider").width() * -6);
				this.playMusic('selectMusic');
				if (position === self.character.length - 1) {
					return false;
				} else {
					$("#slider").animate({
						"marginLeft": (position + 1) * -100 + '%'
					}, {
						complete: function () {
							$(".characterUnit").removeClass('selected').eq(position + 1).addClass('selected');
							self.nowShowCharacter = position + 1;
						},
						duration: 500
					});
				}
			},
			prevcharacter: function (event) {
				let self = this;
				let position = Math.round(parseInt($("#slider").css("marginLeft"), 10) / $("#slider").width() * -6);
				this.playMusic('selectMusic');
				if (position === 0) {
					return false;
				} else {
					$("#slider").animate({
						"marginLeft": (position - 1) * -100 + '%'
					}, {
						complete: function () {
							$(".characterUnit").removeClass('selected').eq(position - 1).addClass('selected');
							self.nowShowCharacter = position - 1;
						},
						duration: 500
					});
				}
			},
			chosecharacter: function (event) {
				let position = Math.round(parseInt($("#slider").css("marginLeft"), 10) / $("#slider").width() * -6);
				this.characterSelect = position;
				if (this.moSceneStep === 'selectCharacter') {
					if (!this.reset) {
						this.moSceneStep = 'help';
					} else {
						this.moSceneStep = 'mainGame';
					}
				}
			},
			replay: function () {
				this.reset = true;
				this.moSceneStep = 'selectCharacter'
			},





			// 場景切換要執行的功能
			// 重新遊戲rest全部
			dataReset: function () {
				/*
					重設全部data讓遊戲可以重新開始
				*/
				this.nowShowCharacter = 0;
				this.blockCoordinate = null;
				this.treasureBoxMoving = false;
				this.treasureNum = 0;
				this.characterState = 0;
				this.totalPoint = 0;
				this.nowProgress = 15000;
				this.fallingTreasureList = [];
				this.treasureGet = [];
				this.treasureBoxPosition = [];
				this.characterSelect = 0;
				this.removeEvent();
				this.demoFallingTreasure = [];
				$(".treasureCore").css("left", (this.sceneWidth - this.treasureBoxWidth) / 2 + 'px');
				$(".startCountDown").find("p").attr('style', '');
				$(".startCountDown").attr('style', '');
				clearTimeout(this.timer);
			},
			// 教學功能
			helpStart: function () {
				this.demo();
			},
			// 遊戲要執行的功能
			mainGameStart: function () {
				/*
					1. 執行開始前倒數
					2. 遊戲時間倒數
					3. 寶物掉落
					4. 計算吃到寶物
					5. 遊戲結束跳下一場景
					6. 關閉陀螺儀操作
				*/

				let self = this;

				self.reset = false;
				self.treasureGet = [];
				$(".treasureCore").css("left", (self.sceneWidth - self.treasureBoxWidth) / 2 + 'px');
				self.randomTreasure();

				setTimeout(function () {
					$(".startCountDown").find("p").eq(0).fadeOut(1000, function () {
						$(".startCountDown").find("p").eq(1).show().fadeOut(1000, function () {
							$(".startCountDown").find("p").eq(2).show().fadeOut(1000, function () {
								$(".startCountDown").find("p").eq(3).show().fadeOut(1000, function () {
									$(".startCountDown").fadeOut('fast');
								});
							});
						});
					});
				});

				setTimeout(function () {
					self.treasureBoxPath();
					self.treasureFall();
					self.countDown();
					self.blockShowing();
				}, 5000);

			},
			// 遊戲結束要執行的功能
			ending: function () {
				/*
					執行遊戲結束動畫
				*/

				this.removeEvent();
			},
			playMusic: function (target) {
				let audio = document.getElementById(target);
				let playPromise = audio.play();
				audio.volume = 1.0;
				audio.currentTime = 0;
				if (playPromise !== undefined) {
					playPromise.then(_ => {
						audio.play();
					})
					.catch(error => {});
				}
			},
			pauseMusic: function (target) {
				let audio = document.getElementById(target);
				let playPromise = audio.play();
				if (playPromise !== undefined) {
					playPromise.then(_ => {
						audio.pause();
					})
					.catch(error => {});
				}
			}
		},
		watch: {
			moSceneStep: function (scene) {
				if (scene === 'selectCharacter' && this.reset) {
					this.dataReset();
					this.pauseMusic('endingMusic');
					this.playMusic('introMusic');
				}
				if (scene === 'help') {
					this.helpStart();
				}
				if (scene === 'mainGame') {
					this.pauseMusic('introMusic');
					this.removeEvent();
					this.addEvent();
					this.mainGameStart();
					if (this.characterSelect === 3) {
						this.playMusic('gamingMusicB');
					} else {
						this.playMusic('gamingMusic');
					}
				}
				if (scene === 'ending') {
					this.ending();
					this.pauseMusic('gamingMusic');
					this.pauseMusic('gamingMusicB');
					this.playMusic('endingMusic');
				}
			},
			helpStep: function (step) {
				if (step === 1) {
					let self = this;
					let randomNum = Math.floor(Math.random() * self.treasureList.length);
					setTimeout(function () {
						$(".help > .hint > .dialog").addClass('show');
					}, 500);

					if (this.device) {
						this.addEvent();
					}
					if (self.treasureList[randomNum].name === 'diamond') {
						self.demoFallingTreasure.push([self.treasureList[randomNum].name + Math.round(Math.random() * 2 + 1), self.treasureList[randomNum].value, self.treasureList[randomNum].size]);
					} else {
						self.demoFallingTreasure.push([self.treasureList[randomNum].name, self.treasureList[randomNum].value, self.treasureList[randomNum].size]);
					}
					setTimeout(function () {
						$(".help > .hint > .dialog").fadeOut('slow');
						setTimeout(function () {
							self.demoTreasureFall();
							self.demoTreasureBoxMove();
						}, 2000);
					}, 3000)
				}
				if (step === 2) {
					let self = this;
					setTimeout(function () {
						self.moSceneStep = "mainGame";
					}, 3000)
				}
			},
			treasureGet: function () {
				if (this.moSceneStep === 'help') {
					let self = this;
					setTimeout(function () {
						self.helpStep = 2;
					}, 2000)
				}
			},
			totalPoint: function (point) {
				if (point > 90000 && point < 190000 && this.characterState !== 1) {
					this.playMusic('powerUpMusic');
					this.characterState = 1;
				}
				if (point >= 190000  && this.characterState !== 2) {
					this.playMusic('powerUpMusic');
					this.characterState = 2;
				}
			}
		},
		mounted () {
			let self = this;
			self.setDevice(window.mobileAndTabletcheck());
			setTimeout(function () {
				if (self.device) {
					document.getElementById('gamingMusic').volume = 0.0;
					document.getElementById('gamingMusic').play();
					document.getElementById('gamingMusic').pause();

					document.getElementById('gamingMusicB').volume = 0.0;
					document.getElementById('gamingMusicB').play();
					document.getElementById('gamingMusicB').pause();

					document.getElementById('endingMusic').volume = 0.0;
					document.getElementById('endingMusic').play();
					document.getElementById('endingMusic').pause();

					document.getElementById('catchMusic').volume = 0.0;
					document.getElementById('catchMusic').play();
					document.getElementById('catchMusic').pause();

					document.getElementById('powerUpMusic').volume = 0.0;
					document.getElementById('powerUpMusic').play();
					document.getElementById('powerUpMusic').pause();

					document.getElementById('selectMusic').volume = 0.0;
					document.getElementById('selectMusic').play();
					document.getElementById('selectMusic').pause();


					self.playMusic('introMusic');
				}
			}, 500);
		}
	}
</script>

<style lang="sass" scoped>
	%clearfix
		zoom: 1
		&::before
			content: ""
			display: table
		&::after
			content: ""
			display: table
			clear: both
	.redirect
		position: relative
		min-width: 1200px
		height: 100%
		background-repeat: no-repeat
		overflow: hidden
		-webkit-background-size: auto 250%
		-o-background-size: auto 250%
		background-size: auto 250%
		background-position: center center
		background-image: url(/static/img/bg-intro.jpg)
		-webkit-transform-origin: center top
		-moz-transform-origin: center top
		-ms-transform-origin: center top
		-o-transform-origin: center top
		transform-origin: center top
	.alert
		position: fixed
		top: 0
		left: 0
		width: 100%
		height: 100%
		background-color: rgba(0, 0, 0, 0.8)
		z-index: 999
		.alertBox
			position: absolute
			top: 0
			left: 0
			right: 0
			bottom: 0
			margin: auto
			width: 454px
			height: 434px
			text-align: center
			background-repeat: no-repeat
			background-position: center center
			background-image: url(/static/img/alert-box.png)
			.text
				margin: 0
				font-size: 25px
				color: #000
				line-height: 1.4em
			.alertType
				margin-top: 240px
			.btn
				margin-top: 20px
				position: relative
				-webkit-border-radius: 30px
				border-radius: 30px
				display: inline-block
				text-align: center
				padding: 2px
				text-decoration: none
				-webkit-box-shadow: #740F10 0 7px 0
				box-shadow: #740F10 0 7px 0
				background: #B22123
				background: -moz-linear-gradient(top, #B22123 0%, #CC3537 100%)
				background: -webkit-linear-gradient(top, #B22123 0%, #CC3537 100%)
				background: linear-gradient(to bottom, #B22123 0%, #CC3537 100%)
				&:active
					margin-top: 27px
					-webkit-box-shadow: none
					box-shadow: none
				span
					position: relative
					padding: 10px 56px
					-webkit-box-sizing: border-box
					-moz-box-sizing: border-box
					box-sizing: border-box
					font-weight: bold
					color: #FFF
					font-size: 26px
					background-color: #B22123
					display: block
					width: 100%
					height: 100%
					-webkit-border-radius: 30px
					border-radius: 30px
	#MobileGame
		position: fixed
		top: 0
		left: 0
		width: 100%
		height: 100%
		-webkit-background-size: auto 1260px
		-o-background-size: auto 1260px
		background-size: auto 1260px
		background-repeat: no-repeat
		background-position: center center
		background-image: url(/static/img/bg-intro.jpg)
		&.bgMask
			&::before
				position: absolute
				content: ""
				display: block
				top: 0
				left: 0
				width: 100%
				height: 100%
				background-color: rgba(0, 0, 0, 0.8)
		&.bg_1
			-webkit-background-size: auto 100%
			-o-background-size: auto 100%
			background-size: auto 100%
			background-position: 46% center
			background-image: url(/static/img/bg_1.jpg)
		&.bg_2
			-webkit-background-size: auto 100%
			-o-background-size: auto 100%
			background-size: auto 100%
			background-image: url(/static/img/bg_2.jpg)
		&.bg_3
			-webkit-background-size: auto 100%
			-o-background-size: auto 100%
			background-size: auto 100%
			background-image: url(/static/img/bg_3.jpg)
		&.bg_4
			-webkit-background-size: auto 100%
			-o-background-size: auto 100%
			background-size: auto 100%
			background-image: url(/static/img/bgm_4.jpg)
		&.bg_5
			-webkit-background-size: auto 100%
			-o-background-size: auto 100%
			background-size: auto 100%
			background-image: url(/static/img/bg_5.jpg)
	.selectCharacter
		position: absolute
		top: 50%
		left: 50%
		-webkit-transform: translate(-50%, -45.5%)
		-moz-transform: translate(-50%, -45.5%)
		-ms-transform: translate(-50%, -45.5%)
		-o-transform: translate(-50%, -45.5%)
		transform: translate(-50%, -45.5%)
		width: 100%
		text-align: center
		overflow: hidden
		.hintSwitch
			position: relative
			display: block
			top: -15px
			margin: 0 0 -10px
			font-size: 18px
			color: #FFF
			font-weight: bold
			text-shadow: rgba(0, 0, 0, 0.8) 1px 1px 10px
		.sceneTitle
			text-align: center
			margin: 0
		.arrow
			position: absolute
			display: inline-block
			top: 50%
			margin-top: -21px
			width: 42px
			height: 42px
			&::before
				position: absolute
				display: block
				content: ""
				top: 0
				left: 0
				bottom: 0
				right: 0
				margin: auto
				width: 18px
				height: 41px
				background-image: url(/static/img/mobile/switch-arrow.png)
				background-position: center
				background-repeat: no-repeat
				-webkit-background-size: auto 100%
				-o-background-size: auto 100%
				background-size: auto 100%
			&.prev
				left: 10px
				&::before
					background-position: 0 0
			&.next
				right: 10px
				&::before
					background-position: -18px 0
		.confirm
			margin: 0 0 10px
			-webkit-border-radius: 30px
			border-radius: 30px
			display: inline-block
			text-align: center
			padding: 1px
			text-decoration: none
			-webkit-box-shadow: #740F10 0 4px 0
			border: 0
			box-shadow: #740F10 0 4px 0
			background: #B22123
			background: -moz-linear-gradient(top, #B22123 0%, #CC3537 100%)
			background: -webkit-linear-gradient(top, #B22123 0%, #CC3537 100%)
			background: linear-gradient(to bottom, #B22123 0%, #CC3537 100%)
			span
				position: relative
				padding: 5px 72px
				-webkit-box-sizing: border-box
				-moz-box-sizing: border-box
				box-sizing: border-box
				font-weight: bold
				color: #FFF
				font-size: 20px
				background-color: #B22123
				display: block
				width: 100%
				height: 100%
				-webkit-border-radius: 30px
				border-radius: 30px

	.characterList
		@extend %clearfix
		position: relative
		text-align: center
		width: 600%
		.pic
			width: 275px
			height: 275px
			display: inline-block
			background-repeat: no-repeat
			overflow: hidden
		.img
			position: absolute
			left: 50%
			background-repeat: no-repeat
		.text
			position: absolute
			z-index: 2
			font-size: 22px
			font-weight: bold
			color: #FFF
			text-shadow: -1px -1px 0 #090204, 1px -1px 0 #090204, -1px 1px 0 #090204, 1px 1px 0 #090204, 0px -1px 0 #090204, 0 1px 0 #090204, 1px 0 0 #090204, -1px 0 0 #090204, 0 -2px 0 #090204, 0 2px 0 #090204, 2px 0 0 #090204, -2px 0 0 #090204, -2px -2px 0 #090204, 2px 2px 0 #090204, -2px 2px 0 #090204, 2px -2px 0 #090204
		.dialog
			position: absolute
			-webkit-box-sizing: border-box
			-moz-box-sizing: border-box
			box-sizing: border-box
			-webkit-background-size: 100% auto
			-o-background-size: 100% auto
			background-size: 100% auto
			background-repeat: no-repeat
			left: 50%
			opacity: 0
			-webkit-transform: translateY(20px)
			-moz-transform: translateY(20px)
			-ms-transform: translateY(20px)
			-o-transform: translateY(20px)
			transform: translateY(20px)
			-webkit-transition-delay: 2s
			-moz-transition-delay: 2s
			-ms-transition-delay: 2s
			-o-transition-delay: 2s
			transition-delay: 2s
			-webkit-transition: opacity 0.5s, transform 0.5s
			-moz-transition: opacity 0.5s, transform 0.5s
			-ms-transition: opacity 0.5s, transform 0.5s
			-o-transition: opacity 0.5s, transform 0.5s
			transition: opacity 0.5s, transform 0.5s
			p
				margin: 0
				font-size: 18px
				font-weight: bold
				color: #000
				text-align: center
				&:first-child
					margin-top: 18px
				&.oneLine
					margin-top: 50px
		.characterUnit
			position: relative
			float: left
			width: 16.6666666666%
			&.selected
				.dialog
					opacity: 1
					-webkit-transform: translateY(0)
					-moz-transform: translateY(0)
					-ms-transform: translateY(0)
					-o-transform: translateY(0)
					transform: translateY(0)
			&.officeLady
				.img
					z-index: 1
					top: 53px
					margin-left: -148px
					width: 101px * 1.44
					height: 148px * 1.44
					background-image: url(/static/img/avatar-officeLady.png)
					-webkit-background-size: 202px * 1.44 auto
					-o-background-size: 202px * 1.44 auto
					background-size: 202px * 1.44 auto
				.text
					margin-left: -25px
					left: 50%
					top: 36%
					letter-spacing: 0.1em
				.dialog
					z-index: 0
					top: 8px
					margin-left: -38px
					width: 161px
					height: 106px
					background-image: url(/static/img/mobile/dialog-yellow-LUP.png)
				.pic
					background-position: 0 0
			&.oldWoman
				.img
					z-index: 0
					top: 50px
					margin-left: -50px
					width: 135px * 1.44
					height: 128px * 1.44
					background-image: url(/static/img/avatar-oldWoman.png)
					-webkit-background-size: 270px * 1.44 auto
					-o-background-size: 270px * 1.44 auto
					background-size: 270px * 1.44 auto
				.text
					margin-left: -85px
					margin-top: -35px
					left: 50%
					top: 36%
					width: 30px
					line-height: 1.2em
				.dialog
					z-index: 1
					top: 144px
					margin-left: -120px
					width: 160px
					height: 105px
					background-image: url(/static/img/mobile/dialog-yellow-LDOWN.png)
				.pic
					background-position: -275px 0
			&.dog
				.img
					top: 97px
					margin-left: -96px
					width: 99px * 1.44
					height: 110px * 1.44
					background-image: url(/static/img/avatar-dog.png)
					-webkit-background-size: 198px * 1.44 auto
					-o-background-size: 198px * 1.44 auto
					background-size: 198px * 1.44 auto
				.text
					margin-top: 5px
					left: 50%
					top: 36%
					width: 30px
					line-height: 1.2em
				.dialog
					z-index: 0
					top: 23px
					margin-left: -60px
					width: 156px
					height: 64px
					background-image: url(/static/img/mobile/dialog-yellow-S.png)
					p:first-child
						margin-top: 13px
				.pic
					background-position: 0 -275px
			&.bride
				.img
					top: 16px
					margin-left: -119px
					width: 72px * 1.44
					height: 173px * 1.44
					background-image: url(/static/img/avatar-bride.png)
					-webkit-background-size: 250px * 1.44 auto
					-o-background-size: 250px * 1.44 auto
					background-size: 250px * 1.44 auto
				.text
					margin-top: 40px
					margin-left: -10px
					left: 50%
					top: 36%
					width: 30px
					line-height: 1.2em
				.dialog
					top: 26px
					margin-left: -34px
					width: 161px
					height: 106px
					background-image: url(/static/img/mobile/dialog-yellow-LUP.png)
				.pic
					background-position: -275px -275px
			&.fatBoy
				.img
					z-index: 0
					top: 16px
					margin-left: -76px
					width: 141px * 1.44
					height: 164px * 1.44
					background-image: url(/static/img/avatar-fatBoy.png)
					-webkit-background-size: 282px * 1.44 auto
					-o-background-size: 282px * 1.44 auto
					background-size: 282px * 1.44 auto
				.text
					margin-top: -50px
					margin-left: -110px
					left: 50%
					top: 36%
					width: 30px
					line-height: 1.2em
				.dialog
					top: 120px
					margin-left: -118px
					z-index: 1
					width: 160px
					height: 105px
					background-image: url(/static/img/mobile/dialog-yellow-LDOWN.png)
				.pic
					background-position: 0 -550px




	.hint
		position: absolute
		z-index: 1
		width: 274px
		top: 36px
		left: 50%
		margin-left: -137px
		text-align: center
		.dialog
			display: inline-block
			vertical-align: top
			width: 200px
			height: 80px
			margin-left: 74px
			background-repeat: no-repeat
			-webkit-background-size: 100% auto
			-o-background-size: 100% auto
			background-size: 100% auto
			background-image: url(/static/img/dialog-hint-Y.png)
			p
				margin-top: 10px
				font-size: 18px
				font-weight: bold
				color: #000

	.mainGame
		position: relative
		z-index: 2
	.timer
		position: absolute
		-webkit-box-sizing: border-box
		-moz-box-sizing: border-box
		box-sizing: border-box
		top: 4px
		right: 10px
		width: 108px
		height: 52px
		background-image: url(/static/img/bg-timeBox.png)
		background-repeat: no-repeat
		background-position: 0 0
		-webkit-background-size: 100%
		-o-background-size: 100%
		background-size: 100%
		font-size: 16px
		text-align: center
		padding: 21px 0 0 28px
		font-weight: bold
	.scoreboard
		position: absolute
		-webkit-box-sizing: border-box
		-moz-box-sizing: border-box
		box-sizing: border-box
		top: 4px
		left: 10px
		width: 121px
		height: 52px
		background-image: url(/static/img/bg-scoreBox.png)
		background-repeat: no-repeat
		background-position: 0 0
		-webkit-background-size: 100%
		-o-background-size: 100%
		background-size: 100%
		font-size: 16px
		text-align: right
		padding: 21px 10px 0 0
		font-weight: bold
	.gameItem
		z-index: 2
		position: absolute
		z-index: 0
		display: block
		height: 100%
		top: 0
		left: 50%
		background-repeat: no-repeat
		background-position: center
		-webkit-background-size: auto 100%
		-o-background-size: auto 100%
		background-size: auto 100%
		&.scene_1
			background-color: #123
		&.scene_2
			background-color: #234
		&.scene_3
			background-color: #345
		&.scene_4
			background-color: #456
		&.scene_5
			background-color: #567
		&.scene_6
			background-color: #678

	.treasureCore
		position: absolute
		margin-top: 55px
		&.notOnRoof
			&::before
				display: none
		&::before
			position: absolute
			display: block
			content: ""
			bottom: -17px
			left: 7px
			width: 156px
			height: 24px
			background-image: url(/static/img/shadow-tsaiShen.png)
		&::after
			position: absolute
			display: block
			content: ""
			width: 100%
			height: 100%
			background-repeat: no-repeat
			background-position: center center
			-webkit-background-size: auto 100%
			-o-background-size: auto 100%
			background-size: auto 100%
			background-image: url(/static/img/tsaiShen.png)
			background-position: 50% 0
		&.right
			&::after
				background-position: 100% 0
		&.left
			&::after
				background-position: 0 0

	.avatar
		position: absolute
		margin: auto
		left: 0
		right: 0
		bottom: 15px
		&::before
			position: absolute
			display: block
			content: ""
			z-index: 0
			left: 50%
			-webkit-border-radius: 50%
			border-radius: 50%
			background-color: rgba(0, 0, 0, 0.2)
		&::after
			position: relative
			display: block
			content: ""
			width: 100%
			height: 100%
			z-index: 1
		.valueHint
			position: absolute
			font-size: 15px
			font-weight: bold
			top: 0px
			opacity: 0
			color: #FFDB45
			text-shadow: -1px -1px 0 #090204, 1px -1px 0 #090204, -1px 1px 0 #090204, 1px 1px 0 #090204, 0px -1px 0 #090204, 0 1px 0 #090204, 1px 0 0 #090204, -1px 0 0 #090204
		&.officeLady
			.valueHint
				right: -20px
			&::before
				bottom: -6px
				left: 12px
				width: 77px
				height: 14px
			&::after
				-webkit-background-size: 202px 448px
				-o-background-size: 202px 448px
				background-size: 202px 448px
				background-image: url(/static/img/avatar-officeLady.png)
			&.state_1
				&::after
					background-position: 0 0
				&.catch
					&::after
						background-position: -101px 0
			&.state_2
				&::after
					background-position: 0 -148px
				&.catch
					&::after
						background-position: -84px -148px
			&.state_3
				&::after
					background-position: 0 -299px
				&.catch
					&::after
						background-position: -67px -299px
		&.oldWoman
			.valueHint
				right: -10px
			&::before
				bottom: -7px
				left: 25px
				width: 93px
				height: 16px
			&::after
				-webkit-background-size: 270px 388px
				-o-background-size: 270px 388px
				background-size: 270px 388px
				background-image: url(/static/img/avatar-oldWoman.png)
			&.state_1
				&::after
					background-position: 0 0
				&.catch
					&::after
						background-position: -135px 0
			&.state_2
				&::after
					background-position: 0 -128px
				&.catch
					&::after
						background-position: -119px -128px
			&.state_3
				&::after
					background-position: 0 -259px
				&.catch
					&::after
						background-position: -120px -259px
		&.dog
			.valueHint
				right: 0
			&::before
				bottom: -6px
				left: -5px
				width: 62px
				height: 15px
			&::after
				-webkit-background-size: 198px 330px
				-o-background-size: 198px 330px
				background-size: 198px 330px
				background-image: url(/static/img/avatar-dog.png)
			&.catch
				&::before
					width: 110px
			&.state_1
				&::after
					background-position: 0 0
				&.catch
					&::after
						background-position: -99px 0
			&.state_2
				&::after
					background-position: 0 -110px
				&.catch
					&::after
						background-position: -99px -110px
			&.state_3
				&::after
					background-position: 0 -220px
				&.catch
					&::after
						background-position: -99px -220px
		&.bride
			.valueHint
				right: -20px
			&::after
				-webkit-background-size: 250px 520px
				-o-background-size: 250px 520px
				background-size: 250px 520px
				background-image: url(/static/img/avatar-bride.png)
			&.state_1
				&::before
					bottom: -7px
					left: 0
					width: 72px
					height: 15px
				&::after
					background-position: 0 0
				&.catch
					&::after
						background-position: -72px 0
			&.state_2
				&::before
					bottom: -7px
					left: -4px
					width: 70px
					height: 15px
				&::after
					background-position: 0 -173px
				&.catch
					&::after
						background-position: -61px -173px
			&.state_3
				&::before
					bottom: -7px
					left: 10px
					width: 110px
					height: 15px
				&::after
					background-position: 0 -346px
				&.catch
					&::after
						background-position: -125px -346px
		&.fatBoy
			.valueHint
				right: -25px
			&::after
				-webkit-background-size: 282px 487px
				-o-background-size: 282px 487px
				background-size: 282px 487px
				background-image: url(/static/img/avatar-fatBoy.png)
			&.state_1
				&::before
					bottom: -7px
					left: 0px
					width: 120px
					height: 15px
				&::after
					background-position: 0 0
				&.catch
					&::after
						background-position: -141px 0
			&.state_2
				&::before
					bottom: -7px
					left: 0px
					width: 100px
					height: 15px
				&::after
					background-position: 0 -164px
				&.catch
					&::after
						background-position: -121px -164px
			&.state_3
				&::before
					bottom: -7px
					left: 15px
					width: 75px
					height: 15px
				&::after
					background-position: 0 -324px
				&.catch
					&::after
						background-position: -120px -324px
	.treasure
		position: absolute
		&::before
			position: absolute
			display: block
			content: ""
			width: 100%
			height: 100%
			top: 0
			left: 0
			z-index: 2
			background-repeat: no-repeat
			background-position: center center
			-webkit-background-size: 100%
			-o-background-size: 100%
			background-size: 100%
		&::after
			position: absolute
			display: block
			content: ""
			width: 10px
			height: 10px
			top: 0
			left: 0
			bottom: 0
			right: 0
			margin: auto
			z-index: 0
			-webkit-border-radius: 50%
			border-radius: 50%
			-webkit-box-shadow: rgba(255, 248, 188, 1) 0 0 20px 6px
			box-shadow: rgba(255, 248, 188, 1) 0 0 20px 6px
		&.coin
			&::before
				background-image: url(/static/img/treasure_coin.png)
		&.redPacket
			&::before
				background-image: url(/static/img/treasure_redPacket.png)
		&.ingots
			&::before
				background-image: url(/static/img/treasure_ingots.png)
		&.diamond1
			&::before
				background-image: url(/static/img/treasure_diamond1.png)
		&.diamond2
			&::before
				background-image: url(/static/img/treasure_diamond2.png)
		&.diamond3
			&::before
				background-image: url(/static/img/treasure_diamond3.png)
	.help
		@extend %clearfix
		position: relative
		height: 100%
		z-index: 1
		.dialog
			opacity: 0
			-webkit-transform: translateY(20px)
			-moz-transform: translateY(20px)
			-ms-transform: translateY(20px)
			-o-transform: translateY(20px)
			transform: translateY(20px)
			-webkit-transition-delay: 2s
			-moz-transition-delay: 2s
			-ms-transition-delay: 2s
			-o-transition-delay: 2s
			transition-delay: 2s
			-webkit-transition: none
			-moz-transition: none
			-ms-transition: none
			-o-transition: none
			transition: none
			&.show
				opacity: 1
				-webkit-transform: translateY(0)
				-moz-transform: translateY(0)
				-ms-transform: translateY(0)
				-o-transform: translateY(0)
				transform: translateY(0)
				-webkit-transition: opacity 0.5s, transform 0.5s
				-moz-transition: opacity 0.5s, transform 0.5s
				-ms-transition: opacity 0.5s, transform 0.5s
				-o-transition: opacity 0.5s, transform 0.5s
				transition: opacity 0.5s, transform 0.5s
		.hintPic
			position: absolute
			bottom: 0
			left: 50%
			margin-left: -98px
			width: 240px
			height: 300px
			font-size: 25px
			-webkit-background-size: auto 100%
			-o-background-size: auto 100%
			background-size: auto 100%
			background-image: url(/static/img/mobile/pic-hint.png)
			-webkit-animation: hand 2s forwards
			-moz-animation: hand 2s forwards
			-o-animation: hand 2s forwards
			animation: hand 2s forwards
			-webkit-animation-iteration-count: 3
			-moz-animation-iteration-count: 3
			-o-animation-iteration-count: 3
			animation-iteration-count: 3
		.dialogReady
			@extend %clearfix
			position: absolute
			top: 0
			left: 0
			right: 0
			bottom: 0
			margin: auto
			width: 295px
			height: 110px
			-webkit-background-size: 100%
			-o-background-size: 100%
			background-size: 100%
			background-image: url(/static/img/mobile/dialog-readyToGo.png)
			.text
				font-weight: bold
				font-size: 18px
				text-align: center
				margin: 28px 0 0 50px
	.mainGame
		width: 100%
		height: 100%
	.startCountDown
		position: absolute
		top: 0
		left: 50%
		margin-left: -500px
		width: 1000px
		height: 100%
		background-color: rgba(0, 0, 0, 0.7)
		p
			position: absolute
			display: none
			margin: 0
			top: 50%
			left: 50%
			-webkit-transform: translate(-50%, -50%)
			-moz-transform: translate(-50%, -50%)
			-ms-transform: translate(-50%, -50%)
			-o-transform: translate(-50%, -50%)
			transform: translate(-50%, -50%)
			font-size: 60px
			text-align: center
			color: #FFF
			font-weight: bold
			&:first-child
				display: block
	.block
		position: absolute
		bottom: -400px
		-webkit-transition: bottom 0.5s
		-moz-transition: bottom 0.5s
		-ms-transition: bottom 0.5s
		-o-transition: bottom 0.5s
		transition: bottom 0.5s
		&.popout
			bottom: 0
		&::before
			position: absolute
			display: block
			content: ""
			z-index: 0
			left: 50%
			-webkit-border-radius: 50%
			border-radius: 50%
			background-color: rgba(0, 0, 0, 0.2)
		&::after
			position: relative
			display: block
			content: ""
			width: 100%
			height: 100%
			z-index: 1
		&.officeLady
			&::before
				bottom: 9px
				left: 12px
				width: 77px
				height: 14px
			&::after
				-webkit-background-size: 202px 448px
				-o-background-size: 202px 448px
				background-size: 202px 448px
				background-image: url(/static/img/avatar-officeLady.png)
			&.state_1
				&::after
					background-position: 0 0
			&.state_2
				&::after
					background-position: 0 -148px
			&.state_3
				&::after
					background-position: 0 -299px
		&.oldWoman
			&::before
				bottom: 8px
				left: 25px
				width: 93px
				height: 16px
			&::after
				-webkit-background-size: 270px 388px
				-o-background-size: 270px 388px
				background-size: 270px 388px
				background-image: url(/static/img/avatar-oldWoman.png)
			&.state_1
				&::after
					background-position: 0 0
			&.state_2
				&::after
					background-position: 0 -128px
			&.state_3
				&::after
					background-position: 0 -259px
		&.dog
			&::before
				bottom: 9px
				left: -5px
				width: 62px
				height: 15px
			&::after
				-webkit-background-size: 198px 330px
				-o-background-size: 198px 330px
				background-size: 198px 330px
				background-image: url(/static/img/avatar-dog.png)
			&.state_1
				&::after
					background-position: -99px 0
			&.state_2
				&::after
					background-position: -99px -110px
			&.state_3
				&::after
					background-position: -99px -220px
		&.bride
			&::after
				-webkit-background-size: 250px 520px
				-o-background-size: 250px 520px
				background-size: 250px 520px
				background-image: url(/static/img/avatar-bride.png)
			&.state_1
				&::before
					bottom: 8px
					left: 0
					width: 72px
					height: 15px
				&::after
					background-position: 0 0
			&.state_2
				&::before
					bottom: 8px
					left: -4px
					width: 70px
					height: 15px
				&::after
					background-position: 0 -173px
			&.state_3
				&::before
					bottom: 8px
					left: 10px
					width: 110px
					height: 15px
				&::after
					background-position: 0 -346px
		&.fatBoy
			&::after
				-webkit-background-size: 282px 487px
				-o-background-size: 282px 487px
				background-size: 282px 487px
				background-image: url(/static/img/avatar-fatBoy.png)
			&.state_1
				&::before
					bottom: -7px
					left: 0px
					width: 120px
					height: 15px
				&::after
					background-position: 0 0
			&.state_2
				&::before
					bottom: 8px
					left: 0px
					width: 100px
					height: 15px
				&::after
					background-position: 0 -164px
			&.state_3
				&::before
					bottom: 8px
					left: 15px
					width: 75px
					height: 15px
				&::after
					background-position: 0 -324px
	.ending
		height: 100%
		.linkSection
			position: fixed
			z-index: 5
			right: 10px
			bottom: 10px
			padding: 8px 10px 0
			.logoSobo
				width: 84px
				height: 15px
			.logoWeddings
				width: 55px
				height: 15px
			a
				display: inline-block
				margin: 0 0 0 4px
				img
					width: 100%
		.btnSection
			margin-top: 15px
			.btn
				cursor: pointer
				display: inline-block
				width: 39px
				height: 39px
				-webkit-border-radius: 20px
				border-radius: 20px
				margin: 0 5px
				vertical-align: top
				color: #FFF
				text-align: center
				svg
					width: 39px
					height: 39px
					display: inline-block
					vertical-align: top
				.text
					line-height: 40px
					margin-left: -5px
			.replay
				width: auto
				padding-right: 12px
				background-color: #E9B200
			.fbShare
				background-color: #4577E1
			.lineShare
				background-color: #00B900
		.outcome
			position: absolute
			text-align: center
			top: 50%
			left: 50%
			-webkit-transform: translate(-50%, -50%)
			-moz-transform: translate(-50%, -50%)
			-ms-transform: translate(-50%, -50%)
			-o-transform: translate(-50%, -50%)
			transform: translate(-50%, -50%)
			.textHint
				font-size: 17px
				font-weight: bold
				color: #FFF
				margin: 0 0 15px
			.outcomeBox
				position: relative
				width: 300px
				height: 260px
				background-repeat: no-repeat
				-webkit-background-size: 100%
				-o-background-size: 100%
				background-size: 100%
				background-position: 0 0
				background-image: url(/static/img/mobile/bg-outcomeBox.png)
				.pic
					display: inline-block
					margin-top: 20px
					width: 200px
					height: 170px
					-webkit-background-size: 600px 850px
					-o-background-size: 600px 850px
					background-size: 600px 850px
					background-image: url(/static/img/mobile/pic-outcome.png)
					&.outcome_1-1
						background-position: 0 0
					&.outcome_1-2
						background-position: -200px 0
					&.outcome_1-3
						background-position: -400px 0
					&.outcome_2-1
						background-position: 0 -170px
					&.outcome_2-2
						background-position: -200px -170px
					&.outcome_2-3
						background-position: -400px -170px
					&.outcome_3-1
						background-position: 0 -340px
					&.outcome_3-2
						background-position: -200px -340px
					&.outcome_3-3
						background-position: -400px -340px
					&.outcome_4-1
						background-position: 0 -510px
					&.outcome_4-2
						background-position: -200px -510px
					&.outcome_4-3
						background-position: -400px -510px
					&.outcome_5-1
						background-position: 0 -680px
					&.outcome_5-2
						background-position: -200px -680px
					&.outcome_5-3
						background-position: -400px -680px
				.totalMoney
					margin-top: 10px
					.text
						font-size: 14px
						font-weight: bold
						color: #C6870E
						margin: 0
					.money
						font-size: 23px
						font-weight: bold
						font-family: "Arial"
						color: #000
						margin: 0
	@keyframes hand
		24.9999%
			background-position: 0 0
		25%
			background-position: -240px 0
		49.9999%
			background-position: -240px 0
		50%
			background-position: -480px 0
		74.9999%
			background-position: -480px 0
		75%
			background-position: -720px 0
		99.9999%
			background-position: -720px 0
		100%
			background-position: -960px 0
</style>


// WEBPACK FOOTER //
// MobileGame.vue?6db4820d